"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Role = void 0;
var Role;
(function (Role) {
    Role["ROTA_ADMIN"] = "ROTA_ADMIN";
    Role["ROTA_AGENT"] = "ROTA_AGENT";
    Role["ROTA_SISENSE_ADMIN"] = "ROTA_SISENSE_ADMIN";
    Role["ROTA_SISENSE_EMBED"] = "ROTA_SISENSE_EMBED";
    Role["REQUESTER"] = "REQUESTER";
    Role["PROVIDER"] = "PROVIDER";
    Role["SCHEDULER"] = "SCHEDULER";
    Role["PROVIDER_SCHEDULER"] = "PROVIDER_SCHEDULER";
    Role["ETC"] = "ETC";
    Role["EVOLVE"] = "EVOLVE";
    Role["TYPE_TEMPLATES"] = "TYPE_TEMPLATES";
    Role["TYPE_TEMPLATE_CREATE"] = "TYPE_TEMPLATE_CREATE";
    Role["TYPE_TEMPLATE_EDIT"] = "TYPE_TEMPLATE_EDIT";
    Role["TYPE_TEMPLATE_ASSIGN"] = "TYPE_TEMPLATE_ASSIGN";
    Role["TIMESHEETS"] = "TIMESHEETS";
    Role["TIMESHEETS_APPROVAL"] = "TIMESHEETS_APPROVAL";
    Role["TIMESHEETS_PRINT"] = "TIMESHEETS_PRINT";
    Role["TIMESHEETS_48HR_RULE_DISABLED"] = "TIMESHEETS_48HR_RULE_DISABLED";
    Role["MEMBERS_BANK"] = "MEMBERS_BANK";
    Role["MEMBERS_BANK_EDIT"] = "MEMBERS_BANK_EDIT";
    Role["MEMBERS_STATE"] = "MEMBERS_STATE";
    Role["MEMBERS_STATE_EDIT"] = "MEMBERS_STATE_EDIT";
    Role["MEMBERS_PAY"] = "MEMBERS_PAY";
    Role["MEMBERS_HISTORY"] = "MEMBERS_HISTORY";
    Role["MEMBERS_VIEW"] = "MEMBERS_VIEW";
    Role["MEMBERS_EDIT"] = "MEMBERS_EDIT";
    Role["MEMBER_COMPLIANCE"] = "MEMBER_COMPLIANCE";
    Role["MEMBER_COMPLIANCE_CREATE"] = "MEMBER_COMPLIANCE_CREATE";
    Role["MEMBER_COMPLIANCE_EDIT"] = "MEMBER_COMPLIANCE_EDIT";
    Role["REPORTS_MY_STAFF"] = "REPORTS_MY_STAFF";
    Role["REPORTS_PAYROLL"] = "REPORTS_PAYROLL";
    Role["REPORTS_PAYROLL_CREATE"] = "REPORTS_PAYROLL_CREATE";
    Role["SHIFTS_CREATE"] = "SHIFTS_CREATE";
    Role["SHIFTS_EDIT"] = "SHIFTS_EDIT";
    Role["SHIFTS_PUBLISH"] = "SHIFTS_PUBLISH";
    Role["SHIFTS_COST"] = "SHIFTS_COST";
    Role["SHIFTS_BOOKINGS"] = "SHIFTS_BOOKINGS";
    Role["SHIFTS_PAY"] = "SHIFTS_PAY";
    Role["SHIFTS_HISTORY"] = "SHIFTS_HISTORY";
    Role["SHIFTS_CANCEL"] = "SHIFTS_CANCEL";
    Role["OVERRIDE_NONCOMPLIANCE"] = "OVERRIDE_NONCOMPLIANCE";
    Role["BOOKINGS_HISTORY"] = "BOOKINGS_HISTORY";
    Role["USER_DELETE"] = "USER_DELETE";
    Role["PARTNER_EDIT"] = "PARTNER_EDIT";
    Role["PARTNER_VIEW"] = "PARTNER_VIEW";
    Role["BRIEFING_TEMPLATES_VIEW"] = "BRIEFING_TEMPLATES_VIEW";
    Role["BRIEFING_TEMPLATES_CREATE"] = "BRIEFING_TEMPLATES_CREATE";
    Role["BRIEFING_TEMPLATES_EDIT"] = "BRIEFING_TEMPLATES_EDIT";
    Role["VENUES_EDIT"] = "VENUES_EDIT";
    Role["VENUES_CREATE"] = "VENUES_CREATE";
    Role["MEMBER_POOLS_VIEW"] = "MEMBER_POOLS_VIEW";
    Role["UNIFORM_TEMPLATES_CREATE"] = "UNIFORM_TEMPLATES_CREATE";
    Role["UNIFORM_TEMPLATES_EDIT"] = "UNIFORM_TEMPLATES_EDIT";
    Role["GENERAL_SETTINGS_VIEW"] = "GENERAL_SETTINGS_VIEW";
})(Role = exports.Role || (exports.Role = {}));
